import { Node } from 'tiptap'
export default class ImagePreloader extends Node {

    get name() {
        return 'image_preloader'
    }

    get schema() {
        return {
            attrs: {
                'data-id': {
                    default: null,
                },
            },
            inline: true,
            group: 'inline',
            selectable: true,
            draggable: true,
            parseDOM: [
                {
                    tag: 'span.preloader',
                    getAttrs: dom => ({
                        'data-id': dom.getAttribute('data-id'),
                    }),
                },
            ],
            toDOM: node => {
                return [
                    'span',
                    {
                        'class': 'preloader',
                        'data-id': node.attrs['data-id'],
                    },
                ]
            },
        }
    }

    get view() {
        return {
            props: ['node', 'updateAttrs', 'view'],
            computed: {
                id: {
                    get() {
                        return this.node.attrs['data-id']
                    },
                    set(id) {
                        this.updateAttrs({
                            'data-id':id,
                        })
                    },
                },
            },
            methods: {
            },
            template: `<span class="preloader">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>`,
        }
    }

    commands({ type }) {
        return {
            image_preloader: attrs => (state, dispatch) => {
                const { selection } = state
                const position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos
                const node = type.create(attrs)
                const transaction = state.tr.insert(position, node)
                dispatch(transaction)
            },
        }
    }

}
